import request from '@/router/axios';

//获取盖章列表
export function sealList(query) {
  return request({
    url: '/api/brandContractAttachment/seal/page',
    method: 'get',
    params: query
  })
}
//盖章
export function clickSeal(query) {
  return request({
    url:'/api/brandContractAttachment/seal',
    method: 'put',
    params: query
  })
}
//查看合同详情
export function wfInfo(query) {
  return request({
    url:'/api/brandContractAttachment/detail',
    method: 'get',
    params:{id:query}
  })
}